import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React, { useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import TextLink from 'components/TextLink';
import Icon from 'components/Icon';
import DropIndicator from 'components/DropIndicator';
import { setAlert } from 'actions/alerts';
var BrowseLink = function BrowseLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: "span"
  }, children));
};
var FileUploader = function FileUploader(_ref2) {
  var onSelect = _ref2.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var selectFile = useCallback(function (acceptedFiles) {
    var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
      selectedFile = _acceptedFiles[0];
    onSelect({
      file: selectedFile
    });
  }, [onSelect]);
  var rejectFile = useCallback(function (rejectedFiles) {
    if (rejectedFiles.length > 1) {
      setAlert({
        title: t('error_upload_only_single_file')
      });
    } else {
      setAlert({
        title: "".concat(t('error_uploading_file'), ": ").concat(rejectedFiles[0].name)
      });
    }
  }, [t]);
  var _useDropzone = useDropzone({
      multiple: false,
      onDropAccepted: selectFile,
      onDropRejected: rejectFile
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  return /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(DropIndicator, {
    p: "m",
    textAlign: "center",
    isDragActive: isDragActive,
    isDragReject: isDragReject
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "upload",
    scale: 4
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_upload_file_drop_file_message"
  }, "Drop a file here or", /*#__PURE__*/React.createElement(BrowseLink, null, "browse"), " to upload"))));
};
export default FileUploader;